import React, { useEffect, useState } from "react";
import { IconButton, Tooltip, Typography } from "@material-ui/core";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import { useDispatch } from "react-redux";
import useStyles from "./ReservationsHeaderStyles";
import { formatTimeDisplay } from "../../../../components/common/PL/Cards/AccessTypeResultCard/utils";
import DialogConfirmation from "../../../../components/common/PL/Dialog/DialogConfirmation";
import { useStore } from "../../../../hooks/useStore";
import { useTranslation } from "../../../../hooks/useTranslation";
import { logout } from "../../../../redux/actions/authActions";
import { spaceScopeTitle } from "../../../../utils/space";

export const ReservationsHeader = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t, BundleKey } = useTranslation();
  const { authStore } = useStore();
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const clock = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(clock);
  }, []);

  // Nombre y etiquetas del espacio a cargo, tal como los armó globalOptions.
  const spaceTitle = spaceScopeTitle(authStore.space);

  const handleConfirmLogout = () => {
    setOpenLogoutDialog(false);
    dispatch(logout());
  };

  return (
    <header className={classes.header}>
      <div className={classes.inner}>
        <img src="/fullLogo.svg" alt="Passapp Logo" className={classes.logo} />
        <div className={classes.meta}>
          <Typography variant="h6" className={classes.timestamp}>
            {formatTimeDisplay(now.toLocaleTimeString())}
          </Typography>
          {spaceTitle && (
            // Una sola línea: el encabezado es fijo y el contenido arranca debajo
            // de una altura conocida.
            <Typography noWrap className={classes.subtitle} title={spaceTitle}>
              {spaceTitle}
            </Typography>
          )}
        </div>
        <Tooltip title={t(BundleKey.LOGOUT_TITLE).toString()}>
          <IconButton
            className={classes.logoutButton}
            aria-label={t(BundleKey.LOGOUT_TITLE)}
            onClick={() => setOpenLogoutDialog(true)}
          >
            <PowerSettingsNewIcon />
          </IconButton>
        </Tooltip>
      </div>
      <DialogConfirmation
        open={openLogoutDialog}
        onClose={() => setOpenLogoutDialog(false)}
        onConfirm={handleConfirmLogout}
        title={t(BundleKey.LOGOUT_TITLE)}
        message={t(BundleKey.LOGOUT_MESSAGE)}
        confirmLabel={t(BundleKey.ACTION_YES)}
        cancelLabel={t(BundleKey.ACTION_NO)}
      />
    </header>
  );
};
